import type { CSSProperties } from 'react';

/**
 * Cột FAB góc phải — từ dưới viewport lên: Hướng dẫn → Góp ý → Hỗ trợ.
 * h-14 = 3.5rem, gap-3 = 0.75rem giữa các nút.
 *
 * z-index cao để luôn trên footer/header. position:fixed qua style inline vì Tailwind CDN
 * đôi khi không sinh utility cho node portal vào document.body → nút thành static, chỉ thấy khi cuộn tới cuối trang.
 */
export const FAB_RIGHT = '1.5rem';
export const FAB_Z = 99990;
export const FAB_Z_OVERLAY = 100000;

/** Cạnh dưới viewport → đáy nút Hướng dẫn (thấp nhất) */
export const FAB_BOTTOM_GUIDE = '1.5rem';
/** Nút Góp ý */
export const FAB_BOTTOM_FEEDBACK = 'calc(1.5rem + 3.5rem + 0.75rem)';
/** Nút Hỗ trợ (cao nhất trong cột) */
export const FAB_BOTTOM_SUPPORT = 'calc(1.5rem + (3.5rem + 0.75rem) * 2)';

/** Box FAB portal: luôn dùng cùng inline position để không phụ thuộc class Tailwind trên body */
export function fabPortalFixedStyle(bottom: string): CSSProperties {
    return {
        position: 'fixed',
        right: FAB_RIGHT,
        bottom,
        left: 'auto',
        top: 'auto',
        zIndex: FAB_Z,
    };
}
